import { render, staticRenderFns } from "./ConfirmSelectionCard.vue?vue&type=template&id=28b0c08e"
import script from "./ConfirmSelectionCard.vue?vue&type=script&lang=js"
export * from "./ConfirmSelectionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports